"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExpired = exports.isUnexpired = void 0;
const msSince = (date) => Date.now() - date.valueOf();
/**
 * Checks if content @param x is unexpired.
 * Throws if @param x doesn't have a cacheTimeInMS set.
 */
const isUnexpired = (x) => {
    if (x.cacheTimeInMS === undefined) {
        throw new Error(`cacheTimeInMS not set on ${JSON.stringify(x)}`);
    }
    else {
        return x.cacheTimeInMS - msSince(new Date(x.lastFetchedMS)) > 0;
    }
};
exports.isUnexpired = isUnexpired;
/**
 * Checks if content @param x is expired
 * Throws if @param x doesn't have a cacheTimeInMS set.
 */
const isExpired = (x) => {
    return !exports.isUnexpired(x);
};
exports.isExpired = isExpired;
//# sourceMappingURL=isExpired.js.map